// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2OW5r","buttons":"RemoveExpirationActionButtons_buttons__2uq3u"};